<!--
 * @Description: 企业开票维护，组件内维护各自状态。工业有客户开票信息
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseDialog
    width="950px"
    class="form-dialog form-dialog--label120 form-dialog-invoice-enterprise"
    title="开票维护"
    :model-value="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    :cancelBtnConfig="{
      show: false
    }"
    :confirmBtnConfig="{ show: false }"
  >
    <BaseTextContent>
      <InvoiceEnterpriseDialogInfo :value="formData.baseInfo" />
      <InvoiceEnterpriseDialogAddress :value="formData.addressList" />
      <InvoiceEnterpriseDialogCategory
        v-if="!isIndustry"
        :value="formData.itemList"
      />
      <InvoiceEnterpriseDialogClient
        v-if="formData.clientList && formData.clientList.length"
        :value="formData.clientList"
      />
    </BaseTextContent>
  </BaseDialog>
</template>

<script lang="tsx" name="invoice-enterprise-dialog" setup>
import { ref, onMounted, computed } from 'vue';
import { BaseDialog, BaseTextContent } from 'xrk-components';
import { basicInformation } from '@V/invoice/src/data-source/apis';
import { BasicInformationData } from '@V/invoice/src/data-source/types';
import InvoiceEnterpriseDialogInfo from './invoice-enterprise-dialog-info.vue';
import InvoiceEnterpriseDialogAddress from './invoice-enterprise-dialog-address.vue';
import InvoiceEnterpriseDialogCategory from './invoice-enterprise-dialog-category.vue';
import InvoiceEnterpriseDialogClient from './invoice-enterprise-dialog-client.vue';

import appStore from '@/store';
import { entpTypeEnum } from '@/common/constants/company/index';
import { storeToRefs } from 'pinia';

withDefaults(
  defineProps<{
    remove?: () => {};
  }>(),
  {
    remove() {
      return () => {
        console.log('remove');
      };
    }
  }
);

const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);
const isIndustry = computed(() => defaultUserFnCode.value === entpTypeEnum.GY);

const formData = ref<BasicInformationData>({
  addressList: [],
  itemList: [],
  baseInfo: {
    entpName: '',
    entpCertNo: '',
    phone: '',
    bankName: '',
    openBankNumber: '',
    companyBusinessAddress: '',
    demand: ''
  },
  clientList: []
});

onMounted(async () => {
  const { data } = await basicInformation();
  formData.value = data;
});
</script>
<style lang="scss">
.form-dialog-invoice-enterprise {
  .form-dialog__title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #1d2129;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin: 24px 0;

    h1 {
      width: auto;
    }
  }

  .form-dialog__content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0 16px;
  }

  .form-dialog__w280 {
    width: 100%;
  }
}
</style>
